import { NextSeo } from 'next-seo';
import { GetPathName } from '@/lib/helpers';
import { PopOver } from '@/components/Popover';

const Page = () => {
  return (
    <>
      <NextSeo
        title="Popover - FHNW Styleguide"
        description="Komponente Popover"
        canonical={`${process.env.NEXT_PUBLIC_BASE_URL}${GetPathName()}`}
      />

      <h1>Popover</h1>
      <PopOver styles={'btn btn-lg btn-primary w-100'} />
    </>
  );
};

export default Page;
